export const watchedBtnProps = {
    remove: {
        text: 'Remove from watched',
        bg: "#ff6b08",
        type: 'remove',
    },
    add: {
        text: 'Add to watched',
        bg: "",
        type: 'add'
        
    }
};

export const queueBtnProps = {
    remove: {
        text: 'Remove from queue',
        bg: "#ff6b08",
        type: 'remove'
    },
    add: {
        text: 'Add to queue',
        bg: "",
        type: 'add'
    }

};